/**
 * View component for /course-certificates/:courseCertificateId
 *
 * Displays a single courseCertificate from the 'byId' map in the courseCertificate reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as courseCertificateActions from '../courseCertificateActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import courseCertificate components
import CourseCertificateLayout from '../components/CourseCertificateLayout.js.jsx';

// import courseCertificate css modules
import courseCertificateStyles from '../courseCertificateModuleStyles.css';


class SingleCourseCertificate extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(courseCertificateActions.fetchSingleIfNeeded(match.params.courseCertificateId));
  }

  render() {
    const { courseCertificateStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual courseCertificate object from the map
     */
    const selectedCourseCertificate = courseCertificateStore.selected.getItem();

    const isEmpty = (
      !selectedCourseCertificate
      || !selectedCourseCertificate._id
      || courseCertificateStore.selected.didInvalidate
    );

    return (
      <CourseCertificateLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Course Certificate </h3>
              {isEmpty ?
                (courseCertificateStore.selected.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: courseCertificateStore.selected.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedCourseCertificate.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Course Certificate </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the CourseCertificate would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </CourseCertificateLayout>
    )
  }
}

SingleCourseCertificate.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    courseCertificateStore: store.courseCertificate
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleCourseCertificate)
);



// WEBPACK FOOTER //
// modules/courseCertificate/views/SingleCourseCertificate.js.jsx